import { MessageCircle, MapPin, Calendar } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { VARIETIES, whatsappFor } from "@/lib/site";

export const Varieties = () => {
  return (
    <section
      id="varieties"
      data-testid="varieties-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-16">
          <div className="lg:col-span-8">
            <FadeIn>
              <p className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-accent font-semibold mb-5">
                Our Varieties
              </p>
            </FadeIn>
            <FadeIn delay={0.1}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]">
                Five legends.
                <br />
                <span className="italic">One harvest season.</span>
              </h2>
            </FadeIn>
          </div>
          <div className="lg:col-span-4">
            <FadeIn delay={0.2}>
              <p className="text-brand-textMuted text-base leading-relaxed">
                Each variety we ship is native to a specific terroir — the soil,
                climate and tradition that make it unmistakably itself. Choose
                your favourite, or let us curate a tasting box.
              </p>
            </FadeIn>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {VARIETIES.map((v, i) => (
            <FadeIn key={v.id} delay={i * 0.08}>
              <article
                data-testid={`variety-card-${v.id}`}
                className={`group h-full flex flex-col rounded-2xl overflow-hidden border border-brand-borderColor bg-brand-base hover:-translate-y-1 hover:shadow-[0_14px_40px_-20px_rgba(28,59,36,0.25)] transition-all duration-500 ${
                  i === 0 ? "lg:col-span-2 lg:row-span-1" : ""
                }`}
              >
                <div
                  className={`relative overflow-hidden ${
                    i === 0 ? "aspect-[2/1]" : "aspect-[4/3]"
                  }`}
                >
                  <img
                    src={v.image}
                    alt={`${v.name} mango`}
                    className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-[900ms] ease-out"
                  />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-1.5 rounded-full bg-[#FDFBF7]/90 backdrop-blur-md border border-white/60 px-3 py-1 text-[10px] uppercase tracking-[0.2em] font-semibold text-brand-accent">
                    {v.tag}
                  </div>
                </div>
                <div className="p-6 sm:p-7 flex-1 flex flex-col">
                  <h3 className="font-display text-2xl sm:text-3xl text-brand-primary">
                    {v.name}
                  </h3>
                  <div className="mt-3 flex flex-wrap gap-4 text-xs text-brand-textMuted">
                    <span className="inline-flex items-center gap-1.5">
                      <MapPin size={13} strokeWidth={1.6} /> {v.region}
                    </span>
                    <span className="inline-flex items-center gap-1.5">
                      <Calendar size={13} strokeWidth={1.6} /> {v.season}
                    </span>
                  </div>
                  <p className="mt-4 text-brand-textMuted text-sm leading-relaxed flex-1">
                    {v.description}
                  </p>
                  <a
                    href={whatsappFor(v.name)}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`variety-order-${v.id}`}
                    className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-brand-primary group/btn"
                  >
                    <MessageCircle size={14} strokeWidth={1.8} />
                    <span className="border-b border-brand-primary/30 group-hover/btn:border-brand-primary pb-0.5 transition-colors">
                      Enquire about {v.name}
                    </span>
                  </a>
                </div>
              </article>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Varieties;
